export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};
